var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPointer = function SvgPointer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.095 1.052V.76h-4.083v14.583h4.083V1.052ZM49.944 4.965l-.243-.162-.162.243-8.13 12.195-.162.243.243.162 3.382 2.255.242.162.162-.243 8.13-12.196.163-.243-.243-.161-3.382-2.255ZM63.939 21.91l-.076-.281-.281.075-14.159 3.794-.281.075.075.282 1.052 3.927.076.281.282-.075 14.158-3.794.281-.075-.075-.282-1.052-3.926ZM15.44 29.782l-.076.282-.281-.076L.925 26.195l-.282-.076.075-.281L1.77 21.91l.076-.281.282.075L16.286 25.5l.281.075-.075.282-1.052 3.926ZM15.193 5.044l-.162-.243-.242.162-3.382 2.255-.243.162.162.242 8.13 12.196.162.243.243-.162 3.382-2.255.242-.161-.161-.243-8.13-12.196Z",
    fill: "#C5B27C",
    stroke: "#C5B27C",
    strokeWidth: 0.583
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.756 68.58H13.833V92.67l12.923 13.588v17.294h43.615v-17.294l6.462-13.588V66.11l-37.154-8.03V29.052H26.756v54.353",
    stroke: "#C5B27C",
    strokeWidth: 5.833
  })));
};
export default SvgPointer;